import Vue from "vue";
import Vuex from "vuex";
import AppModule from "./modules/app";
import LayoutModule from "./modules/layout";
import FormModule from "./modules/form";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app: AppModule,
    layout: LayoutModule,
    form: FormModule,
  },
});
